import React from 'react';
import { IconContainer } from './IconContainer';

const UntestedIcon = () => {
    return (
        <IconContainer ariaLabel="untested">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00001C1.33337 4.31801 4.31804 1.33334 8.00004 1.33334C11.682 1.33334 14.6667 4.31801 14.6667 8.00001C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM8.00004 7.05734L6.11471 5.17134L5.17137 6.11468L7.05737 8.00001L5.17137 9.88534L6.11471 10.8287L8.00004 8.94268L9.88537 10.8287L10.8287 9.88534L8.94271 8.00001L10.8287 6.11468L9.88537 5.17134L8.00004 7.05734Z" fill="#E96666"/>
            </svg>
        </IconContainer>
    )
}

export { UntestedIcon };
